import { render } from "./MyProjects.vue?vue&type=template&id=f0e81f24&scoped=true"
import script from "./MyProjects.vue?vue&type=script&lang=js"
export * from "./MyProjects.vue?vue&type=script&lang=js"

import "./MyProjects.vue?vue&type=style&index=0&id=f0e81f24&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Marti\\Desktop\\Web Development\\portfolio-site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0e81f24"]])

export default __exports__